import { GlobalEmittersService } from 'src/app/services/global-emitters.service';
import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
// import { MatDialog } from '@angular/material/dialog';
import { Observable, Subject, Subscription } from 'rxjs';
import { userActions } from 'src/app/models/enums/user-permissions.enum';
import { UserUtilityService } from 'src/app/services/user-utility.service';
import { SubHeaderData } from '../../../../models/sub-header-data';
import { LayoutService } from '../../../../RefModules/_metronic/core';
import { SubheaderService } from '../../../../RefModules/_metronic/partials/layout';
import { BreadcrumbItemModel } from '../../../../RefModules/_metronic/partials/layout/subheader/_models/breadcrumb-item.model';
import { SettingValueModel, UserSettingModel } from '../../models/informate';
import { takeUntil } from 'rxjs/operators';

@Component({
    selector: 'app-settings-sub-header',
    templateUrl: './settings-sub-header.component.html',
    styleUrls: ['./settings-sub-header.component.scss'],
    standalone: false
})
export class SettingsSubHeaderComponent implements OnInit, OnChanges, OnDestroy {
    @Input() informateForm: UntypedFormGroup;
    @Input() headerData: SubHeaderData;
    @Input() generalTabIndex: any;
    @Input() informateSettingsData: UserSettingModel[];
    @Input() isSaveEnabled: boolean;
    @Input() editProfileForm: UntypedFormGroup;
    @Input() idmsSettingForm: UntypedFormGroup;
    @Input() ruleconfigureForm: UntypedFormGroup;
    @Input() idmsPassPercentageForm: UntypedFormGroup;
    @Output() languageOutput: EventEmitter<SettingValueModel> = new EventEmitter();
    @Output() saveSettingsOutput: EventEmitter<boolean> = new EventEmitter();
    @Output() saveprofile: EventEmitter<boolean> = new EventEmitter();
    @Output() saveInstanceSettingsOutput: EventEmitter<boolean> = new EventEmitter();
    imgSrc: string;
    language: SettingValueModel;
    subheaderCSSClasses = '';
    subheaderContainerCSSClasses = '';
    subheaderMobileToggle = false;
    subheaderDisplayDesc = false;
    subheaderDisplayDaterangepicker = false;
    title$: Observable<string>;
    breadcrumbs$: Observable<BreadcrumbItemModel[]>;
    description$: Observable<string>;
    isAddEnabled: boolean = true;
    isNotificationAddButton: boolean;
    notificationButtonSub: Subscription;
    disableCommunicationSaveBtn: boolean;
    destroy$ = new Subject();
    sharedContentType: string;
    idmsSettingType: string;
    currentOrganizationName: string;
    currentInstanceName: string;
    currentAssetType: string;
    public EditPipeCodes: boolean;
    createPipeCodes: boolean;

    constructor(
        private layout: LayoutService,
        private subheader: SubheaderService,
        private user_utility: UserUtilityService,
        private globalEmittersService: GlobalEmittersService
    ) {
        this.title$ = this.subheader.titleSubject.asObservable();
        this.breadcrumbs$ = this.subheader.breadCrumbsSubject.asObservable();
        this.description$ = this.subheader.descriptionSubject.asObservable();
        this.isNotificationAddButton = false;
        this.disableCommunicationSaveBtn = true;
    }

    async ngOnChanges(changes: SimpleChanges): Promise<void> {
        this.checkAddPermissionOnTabIndex(this.generalTabIndex);
        this.isAddEnabled = await this.user_utility.checkUserPermissionDataAndRoute(
            this.checkAddPermissionOnTabIndex(this.generalTabIndex),
            userActions.Create
        );
        this.imgSrc = this.headerData.defaultImageSrc;
    }

    async ngOnInit(): Promise<void> {
        this.subheaderCSSClasses = this.layout.getStringCSSClasses('subheader');
        this.subheaderContainerCSSClasses = this.layout.getStringCSSClasses('subheader_container');
        this.subheaderMobileToggle = this.layout.getProp('subheader.mobileToggle');
        this.subheaderDisplayDesc = this.layout.getProp('subheader.displayDesc');
        this.subheaderDisplayDaterangepicker = this.layout.getProp('subheader.displayDaterangepicker');
        this.isAddEnabled = await this.user_utility.checkUserPermissionDataAndRoute(
            this.checkAddPermissionOnTabIndex(this.generalTabIndex),
            userActions.Create
        );

        this.notificationButtonSub = this.globalEmittersService.addCommunication.subscribe((res) => {
            this.isNotificationAddButton = res;
        });

        this.globalEmittersService.sharedContentType.pipe(takeUntil(this.destroy$)).subscribe((res) => {
            this.sharedContentType = res;
        });
        if (localStorage.getItem('currentInstanceName')) {
            this.currentInstanceName = localStorage.getItem('currentInstanceName');
        }
        if (localStorage.getItem('selectedOrganizationName')) {
            this.currentOrganizationName = localStorage.getItem('selectedOrganizationName');
        }
        if (localStorage.getItem('currentAssetType')) {
            this.currentAssetType = localStorage.getItem('currentAssetType');
        }
        this.EditPipeCodes = await this.user_utility.checkUserPermissionDataAndRoute('settings-iDMS-pipeCodes', userActions.Edit);
        this.createPipeCodes = await this.user_utility.checkUserPermissionDataAndRoute('settings-iDMS-pipeCodes', userActions.Create);
    }

    checkAddPermissionOnTabIndex(generalTabIndex) {
        //check for add permission
        let permissionPath = '';
        switch (generalTabIndex) {
            case 0:
                permissionPath = 'heroImages';
                break;
            case 1:
                permissionPath = 'news';
                break;
            case 2:
                permissionPath = 'Pricing';
                break;
            case 3:
                permissionPath = 'SocialMedia';
                break;
            // deepcode ignore DuplicateCaseBody: <please specify a reason of ignoring this>
            default:
                permissionPath = 'heroImages';
                break;
        }
        return permissionPath;
    }

    onMouseOver(): void {
        this.imgSrc = this.headerData.mouseOverImageSrc;
    }

    onMouseOut(): void {
        this.imgSrc = this.headerData.defaultImageSrc;
    }

    languageOutputHandler(settingValueModel: SettingValueModel) {
        this.language = settingValueModel;
        this.languageOutput.emit(settingValueModel);
    }

    saveDisabled(): boolean {
        return this.informateFormState();
    }

    informateFormState(): boolean {
        if (!this.informateForm) return true;

        return !(this.informateForm.valid && this.informateForm.dirty);
    }

    editProfileState(): boolean {
        if (this.user_utility.getUserData()?.isSysAdmin) {
            if (!this.editProfileForm?.get('personalDetails') || !this.editProfileForm?.get('emailNotification') || !this.editProfileForm?.get('communication'))
                return true;
            return !(
                this.editProfileForm?.get('personalDetails').dirty ||
                this.editProfileForm?.get('emailNotification').dirty ||
                this.editProfileForm?.get('communication').dirty
            );
        } else {
            if (!this.editProfileForm?.get('personalDetails') || !this.editProfileForm?.get('emailNotification')) return true;
            return !(this.editProfileForm?.get('personalDetails').dirty || this.editProfileForm?.get('emailNotification').dirty);
        }
    }

    disableEditProfile() {
        return this.editProfileState();
    }

    saveSettings(event: MouseEvent) {
        (event.target as HTMLButtonElement).disabled = true;
        this.saveSettingsOutput.emit(true);
    }

    saveInstanceSettings(event: MouseEvent) {
        (event.target as HTMLButtonElement).disabled = true;
        this.isSaveEnabled = false;
        this.saveInstanceSettingsOutput.emit(true);
    }

    saveProfileData() {
        if (this.editProfileForm?.get('personalDetails').dirty) {
            this.globalEmittersService.savePersonalDetails.next(true);
        }

        if (this.editProfileForm?.get('emailNotification').dirty) {
            this.globalEmittersService.saveEmailNotiDetails.next(true);
        }
    }

    // * save button event handler for idms settings
    saveIdmsSetting(): void {
        if (this.idmsSettingForm.get('dbLookUpMaterialAlias') && this.idmsSettingForm.get('dbLookUpMaterialAlias').dirty) {
            this.globalEmittersService.dbSelectLookUpSaveEvent.next(true);
        }
        if (this.idmsSettingForm.get('materialAlias') && this.idmsSettingForm.get('materialAlias').dirty) {
            this.globalEmittersService.materialAliasSaveEvent.next(true);
        }

        if (this.idmsSettingForm.get('pipeCodes') && this.idmsSettingForm.get('pipeCodes').dirty) {
            this.globalEmittersService.pipeCodesSaveEvent.next(true);
        }
        if (this.idmsPassPercentageForm && this.idmsPassPercentageForm.dirty) {
            this.globalEmittersService.passPercentageSaveEvent.next(true);
        }
        if (this.idmsSettingForm.get('barcodeFormGroup') && this.idmsSettingForm.get('barcodeFormGroup').dirty) {
            this.globalEmittersService.barcodeSaveEvent.next(true);
        }
        if (this.idmsSettingForm.get('rulesFormGroup') && this.idmsSettingForm.get('rulesFormGroup').dirty) {
            this.globalEmittersService.rulesSaveEvent.next(true);
        }
    }

    disableHandlerForIdmsSettings(): boolean {
        if (this.idmsSettingForm) {
            const lookUpForm = this.idmsSettingForm?.get('dbLookUpMaterialAlias');
            const materialAliasForm = this.idmsSettingForm?.get('materialAlias');
            const pipeCodesForm = this.idmsSettingForm?.get('pipeCodes');
            const barcodeSettingsform = this.idmsSettingForm?.get('barcodeFormGroup');
            const rulesForm = this.idmsSettingForm.get('rulesFormGroup');

            return (
                !(lookUpForm?.dirty && lookUpForm?.valid) &&
                !(materialAliasForm?.dirty && materialAliasForm?.valid) &&
                !(pipeCodesForm?.dirty && pipeCodesForm?.valid && (this.EditPipeCodes || this.createPipeCodes)) &&
                !(this.idmsPassPercentageForm != undefined && this.idmsPassPercentageForm?.dirty && this.idmsPassPercentageForm?.valid) &&
                !(barcodeSettingsform?.dirty && barcodeSettingsform?.valid) &&
                !(rulesForm?.dirty && rulesForm?.valid)
            ); //
        } else return true;
    }

    ngOnDestroy() {
        if (this.notificationButtonSub) {
            this.notificationButtonSub.unsubscribe();
        }
        this.destroy$.next(null);
        this.destroy$.complete();
    }
}
